import React from 'react';

interface ICheckboxProps {
    name: string;
    label: string;
    value?: string | number | string[];
    checked?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLElement>) => void;
    disabled?: boolean;
}

const CheckboxInput = ({
    name,
    label,
    value,
    checked,
    onChange,
    disabled,
}: ICheckboxProps) => {
    return (
        <div className="checkbox">
            <label>
                <input
                    type="checkbox"
                    value={value}
                    name={name}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                />
                <span>{label}</span>
            </label>
        </div>
    );
};

export default CheckboxInput;
